// import axios from "axios";
import { createContext, useEffect, useState } from "react";

const UserInterfaceContext = createContext();
const UserInterfaceContextProviders = ({ children }) => {
  const [showIframe, setShowIframe] = useState(false);
  const [frameLink, setFrameLink] = useState("Project Name");
  const [frameName, setFrameName] = useState("");
  const [frameLogo, setFrameLogo] = useState("");
  const [projectDetails, setProjectDetails] = useState();
  const [projectCode, setProjectCode] = useState("");
  const projects = [
     {
      code: "EDU-SYNC GHANA",
      demoLink: "https://www.edusyncghana.com/",
      documentationFile: "/resources/Softesc_Documentation.pdf",
      title: "EDU-SYNC GHANA",
      summary:
        "A school management system designed to streamline academic operations and enhance administrative efficiency.",
      overview:
        "SOFTESC is a comprehensive web-based platform for managing school operations such as student enrollment, performance tracking, attendance, staff management, and class scheduling. Designed for schools in underserved communities, it improves data handling and academic reporting with a user-friendly interface.",
      features: [
        "Student and staff registration and management",
        "Class scheduling and attendance tracking",
        "Academic performance management and report generation",
        "Role-based authentication (admin, teacher, student)",
        "Secure cloud-based storage of school data",
      ],
     
      role: "Full-stack developer — developed backend services, front-end dashboard, and managed data models for academic and administrative records.",
      outcomes: [
        "Currently in use by 3 schools in Ghana with over 500 student records managed",
        "Improved administrative efficiency and reduced paper-based workload by 70%",
        "System scaled to handle real-time updates and academic term transitions",
      ],
      links: {
        live: "https://www.edusyncghana.com/",
        github: "",
      },
    },
    {
  code: "IFIX-CAMPUS",
  demoLink: "https://www.ifixcampus.com/",
  documentationFile: "",
  title: "iFix Campus",
  summary:
    "A full-service IT solutions provider built for schools and organizations — covering everything from web development to hardware, networking, and training.",
  overview:
    "iFix Campus was founded to bridge the technology gap in academic institutions and organizations. From setting up network infrastructure to building custom web platforms, iFix Campus delivers end-to-end IT services tailored to the operational needs of schools. The focus is on practical, affordable, and scalable solutions that institutions can rely on long-term.",
  features: [
    "Web design and development for schools and organizations",
    "Hardware supply, setup, and maintenance",
    "Network design, installation, and management",
    "IT consultation and strategic planning",
    "Troubleshooting and technical support",
    "IT training bootcamps for staff and students",
  ],
  role: "Founder & Lead Engineer — responsible for service delivery, client engagement, technical execution, and team coordination across all projects.",
  outcomes: [
    "Delivered IT services to multiple schools and organizations",
    "Built and deployed custom web platforms for academic clients",
    "Trained staff and students through structured IT bootcamp programs",
  ],
  links: {
    live: "https://www.ifixcampus.com/",
    github: "",
  },
},
    {
      code: "LINGUA-CONNECT",
      demoLink: "https://linguaconnect.vercel.app/",
      documentationFile: "/resources/LinguaConnect_Documentation-final.pdf",
      title: "Lingua Connect",
      summary:
        "A real-time messaging platform enabling users to communicate across languages using automatic translation.",
      overview:
        "Lingua Connect is a real-time chat application that bridges language barriers by translating messages between users in different local dialects or languages. It was inspired by the need to improve communication in multicultural and multilingual communities. The platform provides seamless messaging, real-time translation, and a responsive user interface tailored for accessibility.",
      features: [
        "Real-time messaging with WebSocket (Socket.IO)",
        "Automatic language detection and translation using NLP models",
        "User authentication and profile customization",
        "Language preference selection per user",
        "Offline message queue and delivery",
      ],
     
      role: "Full-stack developer — implemented real-time communication, translation integration, user authentication, and designed the front-end interface.",
      outcomes: [
        "Reduced language barrier in chat by over 90% for test users",
        "Successfully handled over 5,000 translated messages in testing phase",
        "Recognized at campus innovation demo for inclusive design",
      ],
      links: {
        live: "https://lingua-connect.vercel.app",
        github: "",
      },
    },
   
   
  ];
  return (
    <UserInterfaceContext.Provider
      value={{
        showIframe,
        setShowIframe,

        frameLink,
        setFrameLink,
        frameName,
        setFrameName,

        frameLogo,
        setFrameLogo,
        projectDetails,
        setProjectDetails,
        projects,

        projectCode,
        setProjectCode,
      }}
    >
      {children}
    </UserInterfaceContext.Provider>
  );
};

export { UserInterfaceContext, UserInterfaceContextProviders };
